import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';

import { EnvironmentUtilService } from '../util';

@Injectable({
  providedIn: 'root',
})
export class ExportApiService {
  environment = this.environmentUtilService.getEnvironment();

  constructor(private environmentUtilService :EnvironmentUtilService) {}

  saveBlobAsFile(data :Blob, fileName :string, ext :string) :void {
    FileSaver.saveAs(data, `${fileName}.${ext}`);
  }
}
